import getGladlyToken from 'services/api/gladChat/getGladlyToken';

export default { getGladlyToken };
